import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom'
import Layout from '../Components/Layout/Layout'
import { updateTokens, setAuthInitialized } from '../store/profile-data.slice'
import { StoreInterface } from '../store/store'
import { AxiosService } from '../services/axios.service'
import { routeConfig, processRouteConfig } from './routeConfig'
import { AuthService } from '../services/auth.service'

const RouterPath = () => {
  const dispatch = useDispatch()

  const checkToken = useCallback(async () => {
    const axiosService = AxiosService.getInstance()
    try {
      const { accessToken, refreshToken } = axiosService.getTokens()

      if (refreshToken) {
        const authService = AuthService.getInstance()
        await authService.getUserDataAndUpdateStore()
        dispatch(updateTokens({ accessToken, refreshToken }))
      } else {
        // Clear any incomplete tokens
        axiosService.clearTokens()
        localStorage.removeItem('@user')
      }
    } catch (error) {
      console.log('validation error: ', error)
      // On token validation failure, clear all tokens
      axiosService.clearTokens()
      localStorage.removeItem('@user')
    } finally {
      dispatch(setAuthInitialized(true))
    }
  }, [dispatch])

  useEffect(() => {
    checkToken()
  }, [checkToken])

  const { accessToken, profile, isAuthInitialized } = useSelector((store: StoreInterface) => {
    return store.profile
  })

  // Don't render routes until auth check is complete
  if (!isAuthInitialized) {
    return null
  }

  const processedRoutes = processRouteConfig(routeConfig, profile, accessToken)

  const router = createBrowserRouter([
    {
      path: '',
      element: <Layout />,
      children: [
        ...processedRoutes,
        {
          path: '*',
          element: <Navigate to="/" replace={true} />,
        },
      ],
    },
  ])
  return <RouterProvider router={router} />
}

export default RouterPath
